import { LOG_IN, LOG_OUT } from '../actions/auth';

const initialState = {
  access_token: null,
}

const auth = (state = initialState, action) => {
  switch(action.type) {
    case `${LOG_IN}_FULFILLED`:
      return action.payload;
    case LOG_OUT:
      return initialState;
    default:
      return state;
  }
}

export default auth;



// WEBPACK FOOTER //
// ./src/reducers/auth.js